/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Cancelsuccess2Inputs */

const zh_adminsubs_cancelsuccess2 = /** @type {(inputs: Adminsubs_Cancelsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅已取消`)
};

const en_adminsubs_cancelsuccess2 = /** @type {(inputs: Adminsubs_Cancelsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription canceled`)
};

const es_adminsubs_cancelsuccess2 = /** @type {(inputs: Adminsubs_Cancelsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción cancelada`)
};

/**
* | output |
* | --- |
* | "Subscription canceled" |
*
* @param {Adminsubs_Cancelsuccess2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_cancelsuccess2 = /** @type {((inputs?: Adminsubs_Cancelsuccess2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Cancelsuccess2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_cancelsuccess2(inputs)
	if (locale === "en") return en_adminsubs_cancelsuccess2(inputs)
	return es_adminsubs_cancelsuccess2(inputs)
});
export { adminsubs_cancelsuccess2 as "adminSubs_cancelSuccess" }